<template>
  <div>
    <Head :title="election.name"/>

    <div class="flex justify-start mb-8">
      <h1 class="text-3xl font-bold">
        <Link class="text-indigo-400 hover:text-indigo-600" :href="route('admin.elections.index')">
          {{ $t('models.election') }}
        </Link>
        <span class="text-indigo-400 font-medium mx-2">/</span>
        {{ $t('actions.update_model_detail', [$t('models.election')]) }}: {{ election.name }}
      </h1>
      <img v-if="election.photo" class="block ml-4 w-8 h-8 rounded-full" :src="election.photo"/>
      <div class="ml-auto">
        <Link class="inline-block btn-indigo mx-2"
              :href="route('admin.elections.candidates.index', election.uuid)">
          <span>{{ $t('models.candidate') }}</span>
        </Link>
        <Link class="inline-block btn-indigo" :href="route('admin.elections.index')">
          <span>{{ $t('ui.back') }}</span>
        </Link>
      </div>
    </div>

    <trashed-message v-if="election.deleted_at" class="mb-6" @restore="restore">
      {{ $t('alerts.current_model_deleted', [$t('models.election')]) }}
    </trashed-message>

    <div class="bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.name" :error="form.errors.name"
                      class="pb-8 pr-6 w-full" :label="$t('fields.election.name')" autofocus/>

          <text-input v-model="form.datetime_start" :error="form.errors.datetime_start"
                      type="datetime-local"
                      :placeholder="datetimeInputPlaceholder" class="pb-8 pr-6 w-full lg:w-1/2"
                      :label="$t('fields.election.datetime_start')"/>

          <text-input v-model="form.datetime_end" :error="form.errors.datetime_end"
                      type="datetime-local"
                      :placeholder="datetimeInputPlaceholder" class="pb-8 pr-6 w-full lg:w-1/2"
                      :label="$t('fields.election.datetime_end')"/>

          <textarea-input v-model="form.description" :error="form.errors.description" rows="4"
                          class="pb-8 pr-6 w-full" :label="$t('fields.election.description')"/>

          <file-input v-model="form.cover_image" :error="form.errors.cover_image"
                      class="pb-8 pr-6 w-full lg:w-1/2" type="file" accept="image/*"
                      :label="$t('fields.election.cover_image')"/>
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button v-if="!election.deleted_at" class="text-red-600 hover:underline"
                  tabindex="-1" type="button" @click="destroy">
            {{ $t('actions.delete_model', [$t('models.election')]) }}
          </button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">
            {{ $t('actions.save') }}
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Layouts/Authenticated'
import TextInput from '@/Inputs/TextInput'
import FileInput from '@/Inputs/FileInput'
import SelectInput from '@/Inputs/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import TextareaInput from "@/Inputs/TextareaInput";

export default {
  components: {
    TextareaInput,
    FileInput,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    election: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        _method: 'put',
        name: this.election.name,
        datetime_start: this.election.datetime_start_input,
        datetime_end: this.election.datetime_end_input,
        description: this.election.description,
        cover_image: null,
      }),
      datetimeInputPlaceholder: `e.g. ${new Date().toLocaleDateString('en-CA')} 18:00`,
    }
  },
  methods: {
    update() {
      this.form.post(route('admin.elections.update', this.election.uuid), {
        onSuccess: () => this.form.reset('photo'),
      })
    },
    destroy() {
      if (confirm('Are you sure you want to delete this election?')) {
        this.$inertia.delete(route('admin.elections.destroy', this.election.uuid))
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this election?')) {
        this.$inertia.put(route('admin.elections.restore', this.election.uuid))
      }
    },
  },
}
</script>
